export const iconFontAwesomeMedicalHealthMicroscope = (
	<i className="fa-solid fa-microscope"></i>
);
